import { z } from "zod";

// TODO: Copied (partially)from firebase/lmt/src/common/types. Replace the file there with imports from this file and move tests if any.

export const RequestStatus = z.enum(["new", "draft", "open", "confirmed", "closed"]);

export type RequestStatus = z.infer<typeof RequestStatus>;
